export const DEFAULT_RNR_OFFSET = 0;
export const DEFAULT_RNR_LIMIT = 5;
export const DEFAULT_RNR_SORTBY = 'help';
export const DEFAULT_SORTBY_TEXT = 'Most Helpful First';

export const DEFAULT_QNA_OFFSET = 0;
export const DEFAULT_QNA_LIMIT = 5;
